import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PageNavBar from "layout/PageNavBar";
import PageFooter from "layout/PageFooter";
import FileDownloadListener from "components/FileDownloadListener";
import { useUser } from "query/user.query";
import { initAppcue } from "utils/appcues";
import { datadogRum } from "@datadog/browser-rum";
import { CommunityBanner } from "components/CommunityBanner";
import { USER_TYPES } from "api/api.typing";
import { appMainClassName, appOutletClassName, appShellClassName, isViewportLockedPath } from "layout/viewportLock";

function MainLayout() {
  const { data: user } = useUser();
  const { pathname } = useLocation();
  const isViewportLocked = isViewportLockedPath(pathname);
  // banner should not appear for Customer reviewers
  const isShouldDisplayBanner = user?.userType !== USER_TYPES.customer;

  useEffect(() => {
    if (user) {
      initAppcue(user);
      datadogRum.setUser({ email: user.email });
    }
  }, [user]);

  return (
    <div className={appShellClassName(isViewportLocked)}>
      <PageNavBar />
      {isShouldDisplayBanner && <CommunityBanner />}
      <main className={appMainClassName(isViewportLocked)}>
        <div className={appOutletClassName(isViewportLocked)}>
          <Outlet />
          <FileDownloadListener />
        </div>
      </main>
      <PageFooter />
    </div>
  );
}

export default MainLayout;
